import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp, ChevronDown } from 'lucide-react';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(true);
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 640);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    const onScroll = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
        setShowScrollDown(false);
      } else {
        setIsVisible(false);
        setShowScrollDown(true);
      }
    };
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    return () => { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onResize); };
  }, []);

  return (
    <>
      <AnimatePresence>
        {isVisible && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="fixed bottom-8 right-8 z-50 p-3 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 group text-primary-foreground"
            style={{ background: 'linear-gradient(135deg, hsl(var(--primary)), hsl(var(--primary-end)))' }}
            whileHover={{ y: -5 }}
            whileTap={{ scale: 0.9 }}
            aria-label="Scroll to top"
            data-testid="scroll-to-top-btn"
          >
            <ArrowUp className="w-6 h-6 group-hover:animate-bounce" />
          </motion.button>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {!isMobile && showScrollDown && window.location.pathname === '/' && (
          <motion.button
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
            className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40 flex flex-col items-center gap-2 text-white cursor-pointer group"
            whileHover={{ y: 5 }}
            aria-label="Scroll down"
            data-testid="scroll-down-indicator"
          >
            <span className="text-sm font-medium opacity-80 group-hover:opacity-100 transition-opacity">Scroll Down</span>
            <motion.div animate={{ y: [0, 10, 0] }} transition={{ repeat: Infinity, duration: 1.5 }}>
              <ChevronDown className="w-8 h-8" />
            </motion.div>
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
